import React from "react";
import MuiRadio from "@material-ui/core/Radio";
import RadioButtonChecked from "../../icons/RadioButtonChecked";
import withStyles from "@material-ui/core/styles/withStyles";

function Radio(props) {
  return <MuiRadio checkedIcon={<RadioButtonChecked />} {...props} />;
}

let styles = theme => ({
  root: {
    color: theme.palette.grey[500],
    transition: `background-color ${theme.transitions.common.short}`,
    "&$checked": {
      color: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.hover
      }
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.hover
    }
  },
  disabled: {
    "&$checked": {
      color: theme.palette.grey[400]
    }
  },
  checked: {}
});

export default withStyles(styles)(Radio);
